import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import {Line} from 'react-chartjs-2';
import faker from 'faker';
import {moderateScale} from '../../tools/Scaling';
import i18n from '../../I18n/i18n';
import {typeExport} from '../../redux/store/type';
import HMTextView from '../HMTextView';
import * as Colors from '../../tools/Colors';
import {View} from 'react-native';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
);

export const options = {
    bezierCurve: false,
    legend: {
        labels: {
            usePointStyle: true,
            boxWidth: moderateScale(10),
            //  fontSize: moderateScale(14)
        },
    },
    font: {family: i18n.locale == 'en' ? null : typeExport.regularFontName},
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
        mode: 'index',
        intersect: false,

    },
    stacked: false,
    plugins: {
        title: {
            display: true,
            text: 'نمودار',
        },
    },
    scales: {

        // yAxis: {
        //     left: {
        //         //fontFamily: "IRANSansMobile(FaNum)_Bold",
        //         fontFamily: i18n.locale == 'en' ? typeExport.regularFontName : typeExport.regularFontName,
        //
        //         axisLineColor: processColor(Colors.colorSecondPrimary),
        //         gridColor: processColor(Colors.colorPrimary),
        //         // labelCount:      6,
        //         labelCountForce: true,
        //         textSize: 14,
        //         axisMinimum: 0,
        //
        //     }
        // },
        yAxes: [
            {
                id: 'y-axis-1',

                type: 'linear',
                display: true,
                position: 'left',
                fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,
                fontWeight: 'bold',

                ticks: {
                    beginAtZero: true,
                },

            },
            {
                id: 'y-axis-2',
                type: 'linear',
                display: false,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                },
                fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,
                fontWeight: 'bold',
            },
        ],

        // y: {
        //     type: 'linear',
        //     display: true,
        //     position: 'left',
        // },
        // y1: {
        //     type: 'linear',
        //     display: true,
        //     position: 'right',
        //     grid: {
        //         drawOnChartArea: false,
        //     },
        // },
    },

};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const data = {
    labels,
    datasets: [
        {
            label: 'Dataset 1',
            data: labels.map(() => faker.datatype.number({min: -1000, max: 1000})),
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
        {
            label: 'Dataset 2',
            data: labels.map(() => faker.datatype.number({min: -1000, max: 1000})),
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
        },
    ],
};

function HMLineChart(props) {
    let {title, styleTitle, styleRootTitle} = props;

    return <View style={{
            flex: 1,
            // width: "100%",
            // height: "100%",
            backgroundColor: '#fff'
            , paddingVertical: moderateScale(10)
            , paddingHorizontal: moderateScale(4)
        }}>
            {title ?
                <HMTextView
                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                    text={title}
                    //  text={"ثبت و بستن تیکت"}
                    type={'bold'}
                    style={[{
                        fontSize: moderateScale(16),
                        marginVertical: moderateScale(2),
                        //     marginHorizontal: moderateScale(4),
                        color: Colors.blackLight,
                    }, styleTitle]}
                    styleRoot={[{alignSelf: 'center'}, styleRootTitle]}
                />
                :
                null
            }

            <Line options={options} data={props.dataChart}/>
        </View>
  ;
}

export default HMLineChart;
